const Auth = {
  login: `${ADMIN_PREFIX}/login/platform/Agency/phone_password`,
  changePassword: `/v2/admin_account/account/reset-password`,
  resetPassword: `${ADMIN_PREFIX}/login/forget`,
  setPaymentPassword: '/v1/agency-platform/agency/userInfo/paymentPassword',
};

const AgencyInfo = {
  userInfo: '/v1/agency-platform-vn-v2/agency/user_info',
};

const Products = {
  getProducts: '/v1/agency-platform/agency/products',
};

const Apply = {
  applyBshTplMotor: '/v1/agency-platform/agency/quote',
};

const CarBrands = {
  getCarBrand: '/v1/agency-platform/agency/get_car_brands',
};

const CarModels = {
  getCarModel: '/v1/agency-platform/agency/get_car_models',
};

const Accounts = {
  getAccounts: '/v1/agency-platform/agency/bankAccounts',
  verifyPaymentPassword:
    '/v1/agency-platform/agency/userInfo/paymentPassword/verify',
  bindAccount: '/v1/agency-platform/agency/bankAccount',
};

const Payment = {
  toPay: '/v1/agency-platform/agency/payment',
};

const Customer = {
  customerList: '/v1/agency-platform/agency/customers',
  customerPolicyList: '/v1/agency-platform/agency/policies/customer/:id',
  policyDetail: '/v1/agency-platform/agency/policies/:id',
  policyDetailByQuoteId: '/v1/agency-platform/agency/policy?quote_id=',
  repay: '/v1/agency-platform/agency/policies/:id/repay',
};

const Earnings = {
  getCommissions: '/v1/agency-platform/agency/commissions',
  getCommissionBalance: '/v1/agency-platform/agency/commissionInfo',
  getCashHistory: '/v1/agency-platform/agency/my_withdrawals',
  goWithdraw: '/v1/agency-platform/agency/withdraw',
};

const Upload = {
  uploadImg: '/v1/agency-platform/noAuth/upload_image',
};
const Onboarding = {
  onboard: '/v1/agency-platform/noAuth/agents',
};

const Business = {
  getStatistics: '/v1/agency-platform/agency/statistics',
  getDownLines: '/v1/agency-platform/agency/downLines',
};

export {
  Auth,
  AgencyInfo,
  Products,
  Apply,
  CarBrands,
  CarModels,
  Accounts,
  Payment,
  Customer,
  Earnings,
  Upload,
  Onboarding,
  Business,
};
